import styles from './Footer.css'
import { PageFooter } from '../../Common/Footer'

const Footer = () => {
  return (
    <footer className={styles.Footer} >
      <div className={styles.breakLine} />
      <PageFooter className={styles.pageFooter} />
    </footer>
  )
}

export default Footer
